<template>
  <div v-if="isOpen" id="alert_modal" class="modal-wrap order_refund_poup">
    <div class="modal-container">
      <div class="modal_header modal_cancel_header">
        <div class="header_txt">
          <div>취소 및 환불 요청</div>
        </div>
      </div>

      <div class="modal_body">
        <div class="modal_contents">
          <div class="purchase_con">
            <div class="order_info">
              <div class="info_details">
                <div class="order_n1">
                  <div class="thumbnail">
                    <img :src="orderData?.thumbnail" alt="상품 이미지" />
                  </div>

                  <div class="order_n2">
                    <div class="info_line">
                      <!-- 이 div로 주문일과 주문번호를 감싸기 -->
                      <div class="order_date">
                        주문일: <span v-html="orderData?.orderDate"></span>
                      </div>
                      <div class="order_number">
                        주문번호: <span v-html="orderData?.orderNo"></span>
                      </div>
                    </div>
                    <div class="product_title" v-html="orderData?.title"></div>
                    <div class="amount">
                      <span v-html="orderData?.amount"></span>원
                    </div>
                  </div>
                </div>
              </div>
              <div class="pay_method cancel_reason">
                <div class="type select_part">구매 취소 사유</div>
                <CustomSelectRefundReason
                  class="init_reason"
                  :options="reasonsArr"
                  :defaultOption="defaultOption"
                  @update:selected="handleSelect"
                />
              </div>
              <div
                v-if="selectedItem?.code === '111199'"
                class="pay_method cancel_reason"
              >
                <div class="type reason_part">기타 사유 입력</div>
                <!-- <input
                  v-model="etcReason"
                  class="init_reason init_etc_text"
                  type="text"
                /> -->
                <textarea
                  v-model="etcReason"
                  placeholder="기타 사유를 입력해주세요."
                  class="init_reason init_etc_text"
                  rows="2"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showValidationError" class="warning_box">
        <span class="warning_reason_part">
          {{ validationErrorMessage }}
        </span>
      </div>
      <div class="refundInfoTxt">
        취소 및 환불은 요청일 기준 7일 이내에 처리 됩니다.<br />
        자세한 사항은 <a href="/AgreeTrem" target="_blank">이용약관</a>을 통해
        확인해주세요.
      </div>
      <div class="modal_footer">
        <div class="btn_area">
          <button class="btn_basic close_btn mt_0" @click="closeModal()">
            취소
          </button>
          <button class="btn_basic" @click="handleSubmit">확인</button>
        </div>
      </div>
    </div>
  </div>
  <div>
    <ModalAlertOrderCancel
      :alertMsg="alert - msg"
      :isOpen="alertStatus"
      @update:isOpen="updateStatus"
      @close="handleAlertClose"
    />
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue'
import CustomSelectRefundReason from './CustomSelectRefundReason.vue'
import ModalAlertOrderCancel from './ModalAlertOrderCancel.vue'
import { loadCancelReason, sendCancelReason } from '../api/orders'

export default {
  name: 'OrderRefundPopup',
  components: {
    CustomSelectRefundReason,
    ModalAlertOrderCancel,
  },
  props: {
    isOpen: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    selectedNo: String,
    // eslint-disable-next-line vue/require-default-prop
    orderData: Object,
  },
  emits: ['update:isOpen', 'refundSuccess', 'showSuccessAlert'],
  setup(props, { emit }) {
    const alertMsg = ref('')
    const alertStatus = ref(false)
    const updateStatus = () => {
      alertStatus.value = false
    }

    const getOrderNo = ref('')
    const loadReasons = ref('')
    const selectedItem = ref(null)
    const defaultOption = { code: '', reason: '취소 사유를 선택해주세요.' }
    const settingReasons = ref('')
    const reasonsArr = {}
    const etcReason = ref('')
    const showValidationError = ref(false)
    const validationErrorMessage = ref('')

    // 선택된 항목이 변경될 때 기타 사유 초기화
    watch(
      () => selectedItem.value,
      (newValue) => {
        if (newValue?.code !== '111199') {
          etcReason.value = ''
          showValidationError.value = false
        }
      }
    )

    const getData = async () => {
      try {
        getOrderNo.value = props.selectedNo
        loadReasons.value = await loadCancelReason()
        settingReasons.value = loadReasons.value.content
        reasonsArr.value = settingReasons.value.map((item) => ({
          code: item.code,
          reason: item.reason,
        }))
      } catch (err) {
        console.log(err)
      }
    }

    const handleSelect = (selected) => {
      selectedItem.value = reasonsArr.value.find(
        (item) => item.reason === selected.reason
      )
    }

    const validateForm = () => {
      if (!selectedItem.value || !selectedItem.value.code) {
        validationErrorMessage.value = '구매 취소 사유를 선택해주세요.'
        return false
      }

      if (selectedItem.value.code === '111199') {
        if (!etcReason.value) {
          validationErrorMessage.value = '기타 사유를 입력해주세요.'
          return false
        }
        if (etcReason.value.length < 5) {
          validationErrorMessage.value = '최소 5자 이상 입력이 필요합니다.'
          return false
        }
      }

      return true
    }
    const closeModal = () => {
      // 모달 닫을 때 초기화
      selectedItem.value = null
      etcReason.value = ''
      showValidationError.value = false
      emit('update:isOpen', false)
    }
    const handleSubmit = async () => {
      showValidationError.value = !validateForm()
      if (showValidationError.value) return

      try {
        const requestRes = await sendCancelReason(
          props.selectedNo,
          selectedItem.value.code,
          selectedItem.value.code === '111199' ? etcReason.value : null
        )
        // console.log(requestRes)
        if (requestRes.status_code === 200) {
          // 성공 상태 코드 확인
          emit('refundSuccess') // 성공 이벤트 발생
          closeModal()
          emit('showSuccessAlert')
          // alertMsg.value = '취소 및 환불 요청이 접수되었습니다.'
          // alertStatus.value = true
        }
      } catch (err) {
        console.log(err)
      }
    }
    // ModalAlertOrderCancel의 closeModal이 호출될 때 실행될 함수
    const handleAlertClose = () => {
      closeModal() // 환불 요청 모달 닫기
    }
    onMounted(() => {
      getData()
    })
    return {
      alertMsg,
      alertStatus,
      updateStatus,
      defaultOption,
      reasonsArr,
      selectedItem,
      etcReason,
      handleSelect,
      handleSubmit,
      getOrderNo,
      closeModal,
      showValidationError,
      validationErrorMessage,
      handleAlertClose,
    }
  },
}
</script>
